import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  Text,
} from "@chakra-ui/react";
import Keyboard from "@/components/keyboard";
import { useState } from "react";
import BgImage from "@/assets/bg.png";
import TitleHeader from "@/components/TitleHeader";
import { useUserInfo } from "@/context/UserInfo";
import { LogsButton } from "@/components/Button";
import { formatAmount, toFixed } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";

const WithdrawAmountModal = ({
  isOpen,
  onClose,
  onValueChange,
}: {
  isOpen: boolean;
  onClose: () => void;
  onValueChange: (value: string) => void;
}) => {
  const { usdcBalance } = useUserInfo();
  const [keyboardValue, setKeyboardValue] = useState("0");
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"full"} autoFocus={false}>
      <ModalContent>
        <ModalBody
          sx={{
            padding: "20px",
            backgroundImage: `url(${BgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <TitleHeader
            color="#D8762B"
            title="Withdraw"
            onBack={onClose}
          ></TitleHeader>
          <Flex
            flexDir={"column"}
            align={"center"}
            sx={{
              marginTop: "20px",
            }}
          >
            <Text
              sx={{
                color: "#848484",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: 700,
              }}
            >
              Withdraw Amount
            </Text>
            <Box
              sx={{
                position: "relative",
                marginTop: "16px",
              }}
            >
              <Text
                sx={{
                  color: "#333",
                  textAlign: "center",
                  fontSize: "50px",
                  fontWeight: 900,
                }}
              >
                {keyboardValue}
              </Text>
              <Flex
                onClick={() => {
                  setKeyboardValue(
                    toFixed(formatAmount(usdcBalance, usdcInfo.decimals), 2)
                  );
                }}
                align={"center"}
                justify={"center"}
                sx={{
                  width: "60px",
                  height: "35px",
                  flexShrink: 0,
                  borderRadius: "100px",
                  background: "#FFD096",
                  color: "#D8762B",
                  fontSize: "13px",
                  fontWeight: 500,
                  position: "absolute",
                  top: "50%",
                  right: "-80px",
                  transform: "translateY(-50%)",
                }}
              >
                Max
              </Flex>
            </Box>

            <Text
              sx={{
                color: "#333",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: 700,
              }}
            >
              USDC
            </Text>
            <Text
              sx={{
                color: "#848484",
                textAlign: "center",
                fontSize: "12px",
                fontWeight: 700,
                marginTop: "6px",
              }}
            >
              Total: {toFixed(formatAmount(usdcBalance, usdcInfo.decimals), 2)}{" "}
              USD
            </Text>
            <LogsButton
              variant="outlined"
              onClick={() => {
                onValueChange(String(keyboardValue));
                onClose();
              }}
              sx={{
                width: "160px",
                height: "70px",
                flexShrink: 0,
                borderRadius: "100px",
                background: "transparent",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 500,
                margin: "20px auto 0",
              }}
            >
              Confirm
            </LogsButton>
          </Flex>

          <Keyboard
            value={keyboardValue}
            onKeyboardClick={(value: string) => {
              const maxAmount = toFixed(
                formatAmount(usdcBalance, usdcInfo.decimals),
                2
              );
              const numValue = Number(value);
              const numMaxAmount = Number(maxAmount);

              if (numValue > numMaxAmount) {
                setKeyboardValue(maxAmount);
              } else {
                setKeyboardValue(value);
              }
            }}
          ></Keyboard>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default WithdrawAmountModal;
